<template>
    <div class="image-info">
        <div class="image-left">
            <div class="Dynamic">
                <div class="head">
                    <div class="user">
                        <img :src="data.user.headIco" class="userIco">
                        <div class="major">
                            <div class="userName">
                                <div>{{data.user.nickName}}</div>
                                <img src="../room/imgs/v1.png" style="width: 15px;height: 15px;margin-left: 5px;">
                            </div>
                            <div class="userMajor"><span v-if="data.user.address.cityName">{{data.user.address.cityName[1]}}</span><span v-if="data.user.major && data.user.address.cityName"> | </span>{{data.user.major}}</div>
                            <div class="userMajor">{{data.creationTime}}</div>
                        </div>

                    </div>

                    <div class="action" v-if="user.uuid == data.user.uuid">
                        <el-dropdown @command="more_action">
					<span class="el-dropdown-link">
						<i class="el-icon-caret-bottom" style="font-size: 24px"></i>
					</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="wxShare" style="display: flex;">
                                    <div style="width: 20px;height: 20px;margin-right: 6px;margin-top: 5px;">
                                        <svg class="wechat" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="2" y="2" width="16" height="16" rx="4" fill="#52C41A"></rect><path d="M13.5466 10.9863C13.6746 10.9846 13.7968 10.933 13.8873 10.8425C13.9778 10.752 14.0294 10.6298 14.0311 10.5018C14.0311 10.2331 13.8158 10.0173 13.5466 10.0173C13.2774 10.0173 13.0621 10.2331 13.0621 10.5018C13.0621 10.7716 13.2779 10.9863 13.5466 10.9863ZM11.1592 10.9863C11.2872 10.9846 11.4095 10.933 11.5 10.8425C11.5905 10.752 11.642 10.6298 11.6437 10.5018C11.6437 10.2331 11.4279 10.0173 11.1592 10.0173C10.8895 10.0173 10.6747 10.2331 10.6747 10.5018C10.6747 10.7716 10.89 10.9863 11.1592 10.9863ZM14.7022 13.7054C14.6677 13.7246 14.6401 13.7543 14.6234 13.7902C14.6067 13.826 14.6018 13.8663 14.6094 13.9051C14.6094 13.931 14.6094 13.9574 14.6229 13.9844C14.6758 14.2093 14.7815 14.5676 14.7815 14.5811C14.7815 14.6205 14.795 14.6469 14.795 14.6739C14.795 14.6895 14.7919 14.705 14.7859 14.7194C14.7799 14.7339 14.7711 14.747 14.7601 14.758C14.749 14.769 14.7358 14.7778 14.7214 14.7837C14.7069 14.7896 14.6914 14.7926 14.6758 14.7926C14.6488 14.7926 14.6359 14.7796 14.6094 14.7667L13.8277 14.3156C13.7706 14.2842 13.7071 14.2661 13.6421 14.2628C13.6027 14.2628 13.5628 14.2628 13.5363 14.2757C13.1651 14.382 12.781 14.4349 12.3704 14.4349C10.3958 14.4349 8.80585 13.1093 8.80585 11.4648C8.80585 9.82092 10.3958 8.49479 12.3704 8.49479C14.3445 8.49479 15.9345 9.82092 15.9345 11.4648C15.9345 12.3534 15.4576 13.1621 14.7022 13.706V13.7054ZM12.521 7.95851C12.4706 7.95684 12.4203 7.95594 12.3699 7.95582C10.118 7.95582 8.26634 9.49883 8.26634 11.4654C8.26634 11.7643 8.3095 12.0534 8.38935 12.3286H8.34133C7.86993 12.3238 7.40121 12.2571 6.94722 12.1301C6.9073 12.1166 6.86737 12.1166 6.82745 12.1166C6.74771 12.1183 6.66987 12.1412 6.60193 12.1829L5.65886 12.7251C5.63188 12.7386 5.60544 12.7521 5.57901 12.7521C5.5405 12.7517 5.5037 12.7362 5.47647 12.709C5.44924 12.6818 5.43376 12.6449 5.43334 12.6064C5.43334 12.5665 5.44629 12.5401 5.45977 12.5002C5.47272 12.4872 5.5925 12.0502 5.65886 11.7858C5.65886 11.7589 5.6718 11.7195 5.6718 11.693C5.67166 11.6468 5.66082 11.6012 5.64014 11.5598C5.61945 11.5185 5.58948 11.4824 5.55257 11.4546C4.63593 10.8055 4.06512 9.83981 4.06512 8.76725C4.06512 6.79639 5.9912 5.20752 8.35428 5.20752C10.3856 5.20752 12.0931 6.37773 12.521 7.95797V7.95851ZM9.7403 8.18403C10.0494 8.18403 10.2938 7.92668 10.2938 7.63049C10.2938 7.32134 10.0494 7.07694 9.7403 7.07694C9.43115 7.07694 9.18675 7.32134 9.18675 7.63049C9.18675 7.93963 9.43115 8.18403 9.7403 8.18403ZM6.90244 8.18403C7.21158 8.18403 7.45652 7.92668 7.45652 7.63049C7.45652 7.32134 7.21158 7.07694 6.90244 7.07694C6.59384 7.07694 6.3489 7.32134 6.3489 7.63049C6.3489 7.93963 6.59384 8.18403 6.90244 8.18403Z" fill="white"></path></svg>
                                    </div>
                                    分享
                                </el-dropdown-item>
                                <el-dropdown-item v-if="user.uuid == data.user.uuid" command="edit">编辑内容</el-dropdown-item>
                                <el-dropdown-item v-if="user.uuid == data.user.uuid"  command="delete" >删除内容</el-dropdown-item>

                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="300px">
                        <div>
                            <vue-qr
                                :text="qr_imgUrl"
                                :size="250"
                                :logoSrc="qr_logo"
                                :logoScale="0.2">
                            </vue-qr>
                        </div>
                    </el-dialog>
                </div>
                <!-- 内容 -->
                <div class="substance">
                    <span class="contentType hand op" @click="toRoom">
                        <i class="el-icon-s-home" style="margin-right: 5px;"></i>
                        <span>{{data.roomName}}</span>
                    </span>
                    <div class="t" style="text-align: center; margin: 2px 0 10px 0; font-size: 16px; font-weight: 600" v-html="data.content.title"></div>
                    <div class="t content" v-html="data.content.content"></div>
                </div>
                <div style="margin-top: 20px" v-if="data.content.enclosure.length > 0">
                  <div class="file-box hand op" @click="downloadFiles(item.url, item.name)" v-for="(item, index) in data.content.enclosure" :key="index">
                    <img src="./imgs/files.png" style="width: 24px; height: 20px; margin-right: 12px; vertical-align: middle">
                    <span style="font-size: 18px; vertical-align: middle">{{item.name}}</span>
                  </div>
                </div>
              <div style="margin: 20px">
                <DynamicOperation :data="data"></DynamicOperation>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DynamicOperation from "@/pages/room/components/DynamicOperation.vue";

    export default {
        name: "articleInfo",
        components: {DynamicOperation},
        computed: {
            user() {
                return this.$store.state.user
            },
            is_login(){
                return this.$store.state.is_login
            },
        },
        data () {
            return {
                data: {
                    user: {},
                    content: {
                      enclosure: []
                    }
                },
                content_list: [],
                dialogVisible:false,
                qr_imgUrl: this.$store.state.mobileUrl,
                qr_logo: require('@/assets/imgs/other/bgb.png'),
            }
        },

        methods: {
            // 跳转到Room
            toRoom() {
                this.$router.push({ path: '/room/info/' + this.data.roomId})
            },

            // 下载附件
            downloadFiles(url, name) {
              this.utils.download(url, name)
            },

            //下拉菜单触发的方法
            more_action:function(e){
                if (this.is_login == 0) {
                    this.err("请先登录");
                    return;
                }
                var that = this;
                if (e == "delete") {
                    that.$confirm('删除后无法恢复，确认删除吗？')
                        .then(_ => {
                            console.log(_);
                          this.newApi.delRoomContent({id:that.data.id}).then(ret =>{
                            if(ret.isSuccess == 1){
                              that.utils.sus(ret.data);
                              that.show = false;
                            }
                          })
                        })
                        .catch(_ => {
                            console.log(_);
                        });
                }

                if (e == "edit") {
                  this.$router.push({name: 'Acticle', query: {id: this.data.id}})
                }

                if(e == 'wxShare'){
                    this.dialogVisible = true;
                    // type 1朋友圈  type 2知识仓库  type 3今日头条 4room文章
                    this.qr_imgUrl = this.qr_imgUrl + "articleInfo/?type=4&id=" + this.data.id;
                    console.log(this.qr_imgUrl)
                }
            },


            // 获取内容
            getRoomContent() {
                var that = this;
                this.newApi.getRoomContentInfo({id: this.$route.params.id}).then(res =>{
                    that.data = res.data
                })
            },
        },

        beforeMount() {

        },

        mounted() {
            this.getRoomContent();
        }
    }
</script>

<style scoped>
    .image-info {
        margin: 0 auto;
        width: 1500px;
        min-height: 100vh;
        display: flex;
    }

    .image-left {
        width: 74%;
        margin-right: 10px;
    }

    .image-right {
        width: 25%;
        padding: 10px 16px;
        margin-bottom: 10px;
        background-color: #ffffff;
        box-shadow: 0 3px 6px 1px rgba(0,0,0,0.1600);
    }

    .Dynamic{
        padding: 24px 38px 10px;
        margin-bottom: 10px;
        background-color: #ffffff;
        box-shadow: 0 3px 6px 1px rgba(0,0,0,0.1600);
    }
    .Dynamic .file-box {
      height: 32px;
      padding: 8px 10px;
      margin-bottom: 4px;
      background-color: #F1F1F1;
    }
    .Dynamic .head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .Dynamic .head .user{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .Dynamic .head .user .userIco{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 12px;
    }
    .Dynamic .head .user .major .userName{
        font-weight: 600;
        color: #444444;
        font-size: 16px;
        display: flex;
        justify-content: flex-start;
        align-items:flex-end;
    }
    .Dynamic .head .user .major .userMajor{
        font-size: 13px;
        color: #999999;
        margin-top: 5px;

    }
    .Dynamic .substance .t{
        width: 100%;
        height: 100%;
        color: #555555;
        margin-right: 10px;
        font-size:14px;
    }
    .Dynamic .substance{
        margin-top: 20px;
        line-height: 26px;
        font-size: 15px;
    }
    .Dynamic .substance .contentType{
        color: #031F88;
        height: 16px;
        font-weight: 600;
        margin-right: 10px;
    }
    .Dynamic .imgs{
        margin-top: 14px;
    }
    .spacebetween{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .Dynamic .volume{
        height: 35px;
        line-height: 35px;
        color: #999999;
        font-size: 14px;
    }
    .Dynamic .bottom{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height:50px;
        height: 50px;
        color: #444444;
        font-size: 16px;
        text-align: center;
    }
    .Dynamic .bottom .btn{
        display: flex;
        justify-content:center;
        align-items: center;
        flex: 1;
    }

    /*.Dynamic>>>img {*/
    /*    width: 100%;*/
    /*}*/
    .mr5{
        margin-right: 5px;
    }
    .t >>> img {
        max-width: 100%;
    }

    .Dynamic .content {
      overflow-x: auto;
    }

</style>
